const TIER_RANK = {
  free: 0,
  pro: 1,
  premium: 2,
};

export const COMPLIMENTARY_PREMIUM_ROLES = new Set(['casting_professional', 'production_company']);
export const isComplimentaryRole = (role) => COMPLIMENTARY_PREMIUM_ROLES.has(role);
export const hasComplimentaryPremiumAccess = (user) => isComplimentaryRole(getActiveRole(user));

export const SUBSCRIBER_DIRECTORY_KEYS = new Set([
  'agents',
  'casting-professionals',
  'companies',
  'crew',
]);

export function getActiveRole(user) {
  return user?.active_role || user?.role || null;
}

export function isAdminUser(user) {
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  return Boolean(
    user?.role === 'admin'
    || user?.active_role === 'admin'
    || user?.is_staff
    || user?.is_master_admin
    || roles.includes('admin')
  );
}

export function getSubscriptionTier(user) {
  if (!user) return 'free';

  const activeRole = getActiveRole(user);
  if (isComplimentaryRole(activeRole)) return 'premium';
  const roleSub = activeRole && user?.role_subscriptions
    ? user.role_subscriptions[activeRole]
    : null;

  return String(
    roleSub?.tier
    || (!Object.keys(user?.role_subscriptions || {}).length && (!user?.subscription_role || user.subscription_role === activeRole)
      ? user?.subscription_tier || user?.membership_tier : null)
    || 'free'
  ).toLowerCase();
}

export function isAtLeastTier(user, requiredTier = 'pro') {
  if (isAdminUser(user)) return true;
  const current = TIER_RANK[getSubscriptionTier(user)] ?? 0;
  const required = TIER_RANK[requiredTier] ?? TIER_RANK.pro;
  return current >= required;
}

export function canViewDirectory(user, directoryKey) {
  if (!SUBSCRIBER_DIRECTORY_KEYS.has(directoryKey)) return true;
  return isAtLeastTier(user, 'pro');
}

export function shouldUseCastingIndexTeaser(user) {
  return !isAtLeastTier(user, 'pro');
}

export function canViewCastingApplicationMeta(user) {
  return isAtLeastTier(user, 'pro');
}

export function canReadNewsStory(user) {
  return isAtLeastTier(user, 'pro');
}
